import TrialNotice from "./TrialNotice";

export default TrialNotice;
